const Accordion = (function ($) {
	return class {
		constructor($el) {
			this.$el = $el;
			this.$containers = this.$el.find('.ui__accordion-item-container');
			this.$headers = this.$el.find('.ui__accordion-item-header');

			this.$containers.on('open-accordion-item', (e) => {
				const $curEl = $(e.currentTarget);

				if ($curEl.hasClass('active')) {
					return;
				}

				$curEl.find('.ui__accordion-item-header').trigger('click');
			});

			this.$headers.on('click tap', (e) => {
				const $parent = $(e.currentTarget).parents('.ui__accordion-item-container').first();

				e.preventDefault();

				if ($parent.hasClass('active')) {
					$parent.removeClass('active');
				} else {
					this.$containers.removeClass('active');
					$parent.addClass('active');

					setTimeout(() => {
						$parent.scrollIntoView(650, 30);
					}, 300);
				}
			});
		}
	};
})(jQuery);

export default Accordion;
